import "react-toastify/dist/ReactToastify.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "./i18n";
import "./App.css";
import { useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "./common/ScrollToTop";
import Navbar from "./Enums/Navbar";
import Footer from "./Enums/Footer";
import { Route, Routes } from "react-router-dom";
import Error404 from "./common/Error404";
import Home from "./Pages/Home";
import Projects from "./Pages/Projects";
import Static from "./Pages/Static";
import ContactUs from "./Pages/ContactUs";
import MediaCenter from "./Pages/MediaCenter";
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
	const lang = useSelector((state) => state?.lang?.lang);
	AOS.init();

	return (
		<div className={`app ${lang}`}>
			<ToastContainer />
			<ScrollToTop />
			<Navbar />
			<div>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/projects" element={<Projects />} />
					<Route path="/terms-conditions" element={<Static type={"terms"} />} />
					<Route path="/privacy-policy" element={<Static type={"privacy"} />} />
					<Route path="/about-us" element={<Static type={"about"} />} />
					<Route path="/contact-us" element={<ContactUs />} />
					<Route path="/media-center" element={<MediaCenter />} />

					<Route path="*" element={<Error404 />} />
				</Routes>
			</div>
			<Footer />
		</div>
	);
}

export default App;
